import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  loading: boolean;
};

const initialState: InitialState = {
  loading: false,
};

const toggleAppBarLoadingSlice = createSlice({
  name: 'toggleAppBarLoading',
  initialState,
  reducers: {
    toggleAppBarLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { toggleAppBarLoading } = toggleAppBarLoadingSlice.actions;
export default toggleAppBarLoadingSlice.reducer;
